module.exports = __webpack_public_path__ + "static/media/NETJE BOVEN BLAUW.9f88602e.png";